export const STATUS_META = {
    created: { label: "Created", color: "#8E8E93" },
    payment_pending: { label: "Payment Pending", color: "#FF9500" },
    confirmed: { label: "Confirmed", color: "#007AFF" },
    technician_assigned: { label: "Technician Assigned", color: "#5856D6" },
    technician_accepted: { label: "Technician Accepted", color: "#5856D6" },
    technician_on_the_way: { label: "On The Way", color: "#FF9500" },
    technician_arrived: { label: "Arrived", color: "#FF2D55" },
    job_started: { label: "Job Started", color: "#AF52DE" },
    job_completed: { label: "Job Completed", color: "#34C759" },
    customer_confirmed: { label: "Customer Confirmed", color: "#34C759" },
    invoice_generated: { label: "Invoice Generated", color: "#E8D399" },
    payment_completed: { label: "Paid", color: "#D4AF37" },
    cancelled: { label: "Cancelled", color: "#8E8E93" },
    refunded: { label: "Refunded", color: "#FF2D55" },
    disputed: { label: "Disputed", color: "#FF2D55" },
};

export const STATUS_TIMELINE = [
    "created",
    "confirmed",
    "technician_assigned",
    "technician_accepted",
    "technician_on_the_way",
    "technician_arrived",
    "job_started",
    "job_completed",
    "invoice_generated",
    "payment_completed",
];

export function currency(amount, code = "AED") {
    if (amount === undefined || amount === null) return "—";
    try {
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: code,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch {
        return `${code} ${Number(amount).toFixed(2)}`;
    }
}

export function fmtDate(iso, opts = {}) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            ...opts,
        });
    } catch {
        return iso;
    }
}

export function fmtDateOnly(iso) {
    return fmtDate(iso, { hour: undefined, minute: undefined });
}
